class FjWholesaleInquiry {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('[data-fj-wholesale-form]');
    if (!this.form) return;

    this.success = section.querySelector('[data-fj-wholesale-success]');
    this.error = section.querySelector('[data-fj-wholesale-error]');
    this.validation = section.querySelector('[data-fj-wholesale-validation]');
    this.submitButton = section.querySelector('[data-fj-wholesale-submit]');
    this.submitTexts = section.querySelectorAll('[data-fj-wholesale-submit-text]');
    this.loader = section.querySelector('[data-fj-wholesale-loader]');
    this.nextButton = section.querySelector('[data-fj-wholesale-next]');
    this.backButton = section.querySelector('[data-fj-wholesale-back]');

    this.scriptUrl = section.dataset.fjScriptUrl;
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.stepTwoClass = 'fj-wholesale-inquiry__form--step-2';

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.nextButton?.addEventListener('click', () => this.goToStep(2));
    this.backButton?.addEventListener('click', () => this.goToStep(1));
  }

  goToStep(stepNumber) {
    if (stepNumber === 2 && !this.validateFields(this.getRequiredFields('[data-fj-step="1"] '))) {
      return;
    }

    this.validation.hidden = true;
    this.form.classList.toggle(this.stepTwoClass, stepNumber === 2);
  }

  getRequiredFields(scope = '') {
    return this.form.querySelectorAll(`${scope}input[required]`);
  }

  validateFields(fields) {
    let valid = true;

    fields.forEach((field) => {
      field.classList.remove('fj-wholesale-inquiry__input--error');

      const emailError = field
        .closest('.fj-wholesale-inquiry__field')
        ?.querySelector('.fj-wholesale-inquiry__field-error');

      if (emailError) emailError.hidden = true;

      if (!field.value.trim()) {
        field.classList.add('fj-wholesale-inquiry__input--error');
        valid = false;
        return;
      }

      if (field.type === 'email' && !this.isValidEmail(field.value)) {
        field.classList.add('fj-wholesale-inquiry__input--error');
        if (emailError) emailError.hidden = false;
        valid = false;
      }
    });

    this.validation.hidden = valid;
    return valid;
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  setLoading(isLoading) {
    this.submitButton.disabled = isLoading;
    this.submitTexts.forEach((text) => {
      text.hidden = isLoading;
    });
    this.loader.hidden = !isLoading;
  }

  async handleSubmit(event) {
    event.preventDefault();

    // Pressing Enter on mobile step 1 should move to step 2, not submit.
    const onStepOne =
      !this.desktopQuery.matches && !this.form.classList.contains(this.stepTwoClass);

    if (onStepOne) {
      this.goToStep(2);
      return;
    }

    if (!this.validateFields(this.getRequiredFields())) return;

    this.error.hidden = true;

    if (!this.scriptUrl) {
      console.error('FjWholesaleInquiry: no submission URL set in the theme editor.');
      this.error.hidden = false;
      return;
    }

    this.setLoading(true);

    try {
      const response = await fetch(this.scriptUrl, {
        method: 'POST',
        body: new FormData(this.form),
      });

      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      this.form.hidden = true;
      this.success.hidden = false;
    } catch (error) {
      console.error('FjWholesaleInquiry: submission failed.', error);
      this.error.hidden = false;
      this.setLoading(false);
    }
  }
}

document.querySelectorAll('.fj-wholesale-inquiry').forEach((section) => {
  new FjWholesaleInquiry(section);
});

// Re-initialize when the section is re-rendered in the theme editor.
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.fj-wholesale-inquiry');
  if (section) new FjWholesaleInquiry(section);
});
